import TranslationsTable from './TranslationsTable';

const ClientPanelTranslations = () => {
  return <TranslationsTable catalog="frontend" subCatalog="default" />;
};

export default ClientPanelTranslations;
